import React, { useContext, useEffect, useRef, useState } from 'react'
import PageHead from '../../Components/PageHead'
import { formatDateToUsaMMDDYYYY, formatDateToMMDDYYYY, convertToBase64, GetAllSchoolsByLocation, LogInUserID, typewatch, getTypeWatchDelay } from '../../JS/Common';
import { ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiPostCall } from '../../JS/Connector';
import Pagination from 'react-js-pagination';
import Popup from '../../Components/Popup';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import { set } from 'lodash';
import Tab from '../../Components/Tab';
import { UserContext } from '../../App';
import Expresstechform from '../Enterprise/Expresstechform';
import { useNavigate } from 'react-router-dom';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';

export default function ResellerGroup() {
    const StateData = useSelector((state) => state.authData);
    const navigate = useNavigate();
    const { UserData } = useContext(UserContext);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [SearchForGroup, setSearchForGroup] = useState("");
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [GridData, setGridData] = useState([]);
    const [Groupaddupdateflag, setGroupaddupdateflag] = useState(1);
    const [MSPAddUpdateFlag, setMSPAddUpdateFlag] = useState(1);
    const [GroupModal, setGroupModal] = useState(false);
    const [MSPModal, setMSPModal] = useState(false);
    const [AllResellers, setAllResellers] = useState([]);
    const [tabs, setTabs] = useState({
        var: 'active',
        msp: ''
    })
    const [viewResellersData, setViewResellersData] = useState({
        members: [],
        attached_schools: [],
    });
    const [ViewUsersPopup, setViewUsersPopup] = useState(false);
    const [ViewCustomersPopup, setViewCustomersPopup] = useState(false);
    const [UserAddUpdateFlag, setUserAddUpdateFlag] = useState(0);
    const [addnewcustomerflag, setaddnewcustomerflag] = useState(0);
    const [phonenoError, setphonenoError] = useState("");
    const [Groupid, setGroupid] = useState("");
    const [data, setData] = useState({
        groupname: "",
        groupdomain: "",
        id: 0
    })
    const [staffData, setStaffData] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
    })
    const [customerSchoolId, setCustomerSchoolId] = useState();
    const [AllSchool, setAllSchool] = useState([]);
    const [editingUserId, setEditingUserId] = useState(null);
    const showPagination = GridData.length > 0;
    const UploadDocFile = useRef();
    const [uploadedFile, setUploadedFile] = useState({
        FileName: '',
        Document: ''
    });
    const [Params, setParams] = useState({
        Sortbykey: null,
        SortbyFlag: "desc"
    });
    const [allData, setAllData] = useState({
        UserType: 2,
        CompanyName: "",
        RegisterDate: new Date().toISOString().split('T')[0],
        CustomFeature: 0,
        Email: "",
        FedexDoc: "",
        FedexDocName: "",
        PrimaryText: "",
        SecondaryText: "",
        PrimaryColor: "#3cbba5",
        SecondaryColor: "#4c5258",
        Logo: "",
        shoppingLink: '',
        defaultLocation: '',
        shipping_client_id: '',
        shipping_secrete_id: '',
        shipping_address_line_1: '',
        shipping_address_line_2: '',
        shipping_city: '',
        shipping_state: '',
        shipping_zipcode: '',
    });
    const [Locations, setLocations] = useState([]);
    useEffect(() => {
        GetAllSchoolsByLocation({ setLocations });
    }, []);
    function handleSearchChange(e) {
        setSearchForGroup(e.target.value)
        setCurrentPage(1);
        GetData(e.target.value, Params.Sortbykey, false);
    }
    useEffect(() => {
        GetData(null, Params.Sortbykey, false);
    }, [currentPage, LimitForPagination, tabs]);
    async function GetData(SearchString, sortbykey, toogleSort) {
        if (!SearchString) SearchString = null;
        if (sortbykey && toogleSort) Params.SortbyFlag = Params.SortbyFlag == "asc" ? "desc" : "asc";
        setSearchForGroup(SearchString);
        setParams({ ...Params, Sortbykey: sortbykey });
        typewatch(async function () {
            setLoading(true);
            const effectiveRole = UserData.copyrole || UserData.role || null;
            const logInUserId = hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR) ? LogInUserID : null;
            await ApiGetCall(`/${tabs?.var == 'active' ? 'resellers/groups/all' : 'resellers/msp/users/all'}?search=${SearchString}&sortBy=${sortbykey}&sortByOrder=${Params.SortbyFlag}&page=${currentPage}&limit=${LimitForPagination}&userId=${logInUserId}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    setpageRangeCount(responseRs?.msg?.total)
                    setGridData(responseRs.msg.data.length ? responseRs.msg.data : [])
                }
            });
        }, getTypeWatchDelay(SearchString, 500));
    }
    const handleGroupModal = async () => {
        setGroupModal(true);
        setAllResellers([]);
        setGroupaddupdateflag(1);
        setData({ ...data, groupname: "", groupdomain: "", id: 0 });
    }
    const handleMSPModal = async () => {
        navigate('/add-msp')
    }
    function handleCheckboxChange(id, email) {
        setAllResellers((prev) => {
            const isOriginal = AllResellers.some(r => r.id === id);
            const existing = prev.find((r) => r.id === id);

            if (existing) {
                if (existing.flag === 2) {
                    // Was previously unselected (flag 2) → now re-selected → set flag to 1
                    return prev.map((r) => r.id === id ? { ...r, flag: 1 } : r);
                }

                if (isOriginal) {
                    // Was originally selected → now unselected → set flag to 2
                    return prev.map((r) => r.id === id ? { ...r, flag: 2 } : r);
                } else {
                    // Was newly selected → now unselected → remove from list
                    return prev.filter((r) => r.id !== id);
                }
            } else {
                // Newly selected → add with flag 1
                return [...prev, { id, email, flag: 1 }];
            }
        });
    }
    async function viewResellerStaffs(groupid, flag) {
        setAllResellers([])
        setViewResellersData({ members: [], attached_schools: [] });
        setGroupid(groupid);
        setLoading(true);
        if (flag == 1) {
            setViewUsersPopup(true);
        } else {
            setViewCustomersPopup(true)
        }
        await ApiGetCall(`/resellers/groups/members?groupId=${groupid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setViewResellersData({
                    members: responseRs.members || [],
                    attached_schools: responseRs.attached_schools || [],
                });
            }
        });
    }
    async function handleSavegroup(flag) {
        var isFormValid = CheckValidation({ formID: 'groupmodal' });
        if (!isFormValid) return;
        setLoading(true);
        const UserArray = AllResellers.filter(r => r.flag === 1 || r.flag === 2);
        var raw = JSON.stringify({
            groupName: data.groupname,
            groupDomain: data.groupdomain,
            uuid: data.id,
            users: Groupaddupdateflag == 1 ? [] : UserArray
        });
        await ApiPostCall("/resellers/groups/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.status == "success") {
                    var msg = Groupaddupdateflag == 1 ? "External Customer Created Successfully." : "External Customer Updated Successfully.";
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setLoading(false);
                        if (flag == 1) {
                            setGroupModal(false);
                        } else {
                            setViewUsersPopup(false)
                        }
                        setNewAlerts(<AlertsComp show={false} />)
                        GetData(SearchForGroup, Params.Sortbykey, false);
                    }, 3500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 4500);
                }
            }
        });
    }
    async function handleSaveStaffMember(flag) {
        if (flag == 1) {
            var isFormValid = CheckValidation({ formID: 'staffmembermodal' });
            if (staffData.phoneNumber != "") {
                if (staffData.phoneNumber.length < 10 || staffData.phoneNumber.length > 10) {
                    setphonenoError("Invalid Phone No.");
                    isFormValid = false;
                } else {
                    setphonenoError("");
                }
            }
            if (!isFormValid) return;
        } else {
            var isFormValid = CheckValidation({ formID: 'staffmembereditmodal' });
            if (staffData.phoneNumber != "") {
                if (staffData.phoneNumber.length < 10 || staffData.phoneNumber.length > 10) {
                    setphonenoError("Invalid Phone No.");
                    isFormValid = false;
                } else {
                    setphonenoError("");
                }
            }
            if (!isFormValid) return;
        }
        setEditingUserId(null); // exit edit mode after save
        setLoading(true);
        var raw = JSON.stringify({
            uuid: UserAddUpdateFlag == 1 ? 0 : staffData.id,
            firstName: staffData.firstName,
            lastName: staffData.lastName,
            phoneNumber: staffData.phoneNumber,
            email: staffData.email?.includes('@') ? staffData.email : staffData.email + "@" + data.groupdomain,
            flag: UserAddUpdateFlag,
            groupId: Groupid
        });
        await ApiPostCall("/resellers/staff/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = UserAddUpdateFlag == 1 ? "User Added Successfully." : "User Updated Successfully.";
                    setNewAlerts(
                        <AlertsComp show={true} variant="success" msg={msg} />
                    );
                    setUserAddUpdateFlag(0);
                    viewResellerStaffs(Groupid, 1);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);

                        GetData(SearchForGroup, Params.Sortbykey, false);
                    }, 2000);
                } else {
                    setNewAlerts(
                        <AlertsComp show={true} variant="danger" msg={responseRs.message} />
                    );
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function getGroupEditData(id) {
        setLoading(true);
        await ApiGetCall(`/resellers/groups/data?groupId=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setData({
                    groupname: responseRs.msg.group_name,
                    groupdomain: responseRs.msg.group_domain,
                    id: responseRs.msg.id
                });
                setAllResellers(responseRs?.msg?.user_array);
            }
        });
    }
    async function getStaffEditData(id) {
        setLoading(true);
        await ApiGetCall(`/resellers/staff/by-id?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setStaffData({
                    firstName: responseRs.first_name,
                    lastName: responseRs.last_name,
                    phoneNumber: responseRs.phone_number,
                    email: responseRs.email,
                    id: responseRs.id
                });
            }
        });
    }
    const groupBody = (
        <div className='row parent' id="groupmodal">
            <div className="row">
                <div className="col-md-6">
                    <div className='FormLabel'>VAR Name<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="groupname"
                            className="form-control" required value={data.groupname}
                            onChange={(e) => setData({ ...data, groupname: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='FormLabel'>VAR Domain<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="groupdomain"
                            disabled={Groupaddupdateflag == 2}
                            className="form-control" required value={data.groupdomain}
                            onChange={(e) => setData({ ...data, groupdomain: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>

            </div>
        </div>
    )
    const StaffmemberBody = (
        <div className='row parent greyBox mt-3' id="staffmembermodal">
            <div className="row">
                <div className="col-md-6">
                    <div className='FormLabel fw-600'>First Name<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="firstname"
                            className="form-control" required value={staffData.firstName}
                            onChange={(e) => setStaffData({ ...staffData, firstName: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className='FormLabel fw-600'>Last Name<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="text" autoComplete="off" name="lastname"
                            className="form-control" required value={staffData.lastName}
                            onChange={(e) => setStaffData({ ...staffData, lastName: e.target.value })} />
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
                <div className="col-md-6 pt-3">
                    <div className='FormLabel fw-600'>Phone Number<label className='redText'>*</label></div>
                    <div className="ps-0">
                        <input type="number" autoComplete="off" name="phonenumber"
                            className="form-control" required value={staffData.phoneNumber}
                            onChange={(e) => setStaffData({ ...staffData, phoneNumber: e.target.value })}
                            onKeyDown={(e) => {
                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                    e.preventDefault();
                                }
                            }} />
                        <span className="form-text invalid-feedback" > *required </span>
                        <span className="Emailinvalid">{phonenoError}</span>
                    </div>
                </div>
                <div className="col-md-6 pt-3">
                    <div className='FormLabel fw-600'>Email<label className='redText'>*</label></div>
                    <div className="ps-0 d-flex align-items-center">
                        <input type="text" autoComplete="off" name="email"
                            className="form-control me-2" required value={staffData.email}
                            onChange={(e) => !e.target.value.includes('@') && setStaffData({ ...staffData, email: e.target.value })} />
                        <span>@{data?.groupdomain}</span>
                        <span className="form-text invalid-feedback" > *required </span>
                    </div>
                </div>
            </div>
            <div className='col-12 text-center mt-3'>
                <label className="ms-2 cursor-pointer" onClick={(e) => {
                    setUserAddUpdateFlag(0);
                }}><u>Cancel</u></label>
                <button
                    className="ms-2 SaveBtn cursor-pointer"
                    style={{
                        background: "var(--primary-color)", color: "white"
                    }}
                    onClick={() => {
                        handleSaveStaffMember(1);
                    }}>
                    Save
                </button>
            </div>
        </div>
    )
    const groupusersBody = (
        <div className="px-2">
            <div className='col-12 text-end mb-2'>
                <button
                    title='Add User'
                    className="SaveBtn cursor-pointer"
                    style={{ background: "var(--primary-color)", color: "white" }}
                    onClick={() => {
                        setUserAddUpdateFlag(1);
                        setEditingUserId(null)
                        setStaffData({ ...staffData, firstName: "", lastName: "", phoneNumber: "", email: "" });
                    }}>
                    Add User
                </button>
            </div>
            <div className="px-2 mb-3">
                {
                    UserAddUpdateFlag == 1 &&
                    StaffmemberBody
                }
            </div>
            {
                viewResellersData.members?.length > 0 ? (
                    <div className='col-12 greyBox data-table-container'>
                        <table className="table data-table mb-0" >
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col">First Name </th>
                                    <th scope="col">Last Name </th>
                                    <th scope="col">Email </th>
                                    <th scope="col">Phone no. </th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewResellersData.members.map((item, i) => {
                                    const isEditing = editingUserId === item.id;

                                    return (
                                        <tr key={i} className={`OddEvenClass tableBorderHide parent`} id="staffmembereditmodal">
                                            {/* First Name */}
                                            <td className="py-12">
                                                {isEditing ? (
                                                    <>
                                                        <input
                                                            type="text"
                                                            autoComplete="off"
                                                            name="firstname"
                                                            required
                                                            className="form-control"
                                                            value={staffData.firstName}
                                                            onChange={(e) =>
                                                                setStaffData({ ...staffData, firstName: e.target.value })
                                                            }
                                                        />
                                                        <span className="form-text invalid-feedback" > *required </span>
                                                    </>
                                                ) : (
                                                    item.first_name
                                                )}
                                            </td>

                                            {/* Last Name */}
                                            <td className="py-12">
                                                {isEditing ? (
                                                    <>
                                                        <input
                                                            type="text"
                                                            autoComplete="off"
                                                            name="lastname"
                                                            required
                                                            className="form-control"
                                                            value={staffData.lastName}
                                                            onChange={(e) =>
                                                                setStaffData({ ...staffData, lastName: e.target.value })
                                                            }
                                                        />
                                                        <span className="form-text invalid-feedback" > *required </span>
                                                    </>
                                                ) : (
                                                    item.last_name
                                                )}
                                            </td>

                                            {/* Email */}
                                            <td className="py-12">
                                                {isEditing ? (
                                                    <>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='d-flex flex-column pe-1'>
                                                                <input
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    name="email"
                                                                    required
                                                                    className="form-control me-2"
                                                                    value={staffData.email?.split("@")[0]}
                                                                    onChange={(e) =>
                                                                        !e.target.value?.includes('@') && setStaffData({ ...staffData, email: e.target.value })
                                                                    }
                                                                />
                                                                <span className="form-text invalid-feedback" > *required </span>
                                                            </div>
                                                            <span>@{data.groupdomain}</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    item.email
                                                )}
                                            </td>

                                            {/* Phone Number */}
                                            <td className="py-12">
                                                {isEditing ? (
                                                    <>
                                                        <input
                                                            type="number"
                                                            autoComplete="off"
                                                            required
                                                            name="phonenumber"
                                                            className="form-control"
                                                            value={staffData.phoneNumber}
                                                            onChange={(e) =>
                                                                setStaffData({ ...staffData, phoneNumber: e.target.value })
                                                            }
                                                            onKeyDown={(e) => {
                                                                if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <span className="form-text invalid-feedback" > *required </span>
                                                    </>
                                                ) : (
                                                    item.phone_number
                                                )}
                                            </td>

                                            {/* Actions */}
                                            <td className="py-12">
                                                {!isEditing ? (
                                                    <img
                                                        src="/images/edit_icon.svg"
                                                        title="Edit User"
                                                        className="img-fluid pe-2 cursor-pointer"
                                                        onClick={() => {
                                                            setUserAddUpdateFlag(2);
                                                            getStaffEditData(item.id); // load data into staffData
                                                            setEditingUserId(item.id); // only this row switches to edit mode
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src="/images/save_icon.svg"
                                                        title="Save User"
                                                        className="img-fluid pe-2 cursor-pointer"
                                                        onClick={() => {
                                                            handleSaveStaffMember(2);
                                                        }}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>

                        </table>
                    </div>
                ) : (
                    <div className="text-center">No Users Found.</div>
                )
            }
            {AllResellers.length > 0 &&
                <div className='greyBox p-3 mt-3 parent' id="groupmodal">
                    <div className='col-12'>
                        <b>Select External Users</b>
                    </div>
                    <div className='row'>
                        {AllResellers.length > 0 && AllResellers.map((item, i) => {
                            const allChecked = AllResellers.length > 0 && AllResellers.every(r => r.flag === 1);
                            return <div className='col-md-6 col-12 pt-2' key={i}>
                                <div className='align-items-center py-1 d-flex px-0 text-break'>
                                    <input className='form-check-input mt-0 me-2 ms-0 cursor-pointer'
                                        type="checkbox" checked={item.flag == 1}
                                        onChange={() => handleCheckboxChange(item.id, item.email)} />
                                    {item.email}
                                </div>
                            </div>
                        })}
                    </div>
                    <div className='d-flex justify-content-center'>
                        <button className='SaveBtn cursor-pointer mt-2 ' onClick={(e) => handleSavegroup(2)}>Save</button>
                    </div>
                </div>
            }

        </div >
    );
    function ShowFileName() {
        const fileInput = UploadDocFile.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 5 });
        if (!isFileValid) {
            setUploadedFile({ ...uploadedFile, FileName: validationMsg, Document: '' });
            return
        }
        setUploadedFile({ ...uploadedFile, FileName: filename, Document: files });
    }
    const openPDFInNewTab = (doc) => {
        if (doc instanceof File) {
            // Handle local file
            const fileURL = URL.createObjectURL(doc);
            window.open(fileURL, '_blank');
        } else if (typeof doc === "string" && doc !== "") {
            // Handle CDN file path
            ApiGetCDNData("/" + doc, StateData?.Schoolnumber).then((blob) => {
                try {
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                } catch (err) {
                    log.error(err)
                }
            });
        }
    };
    const handleSaveSchoolDocument = async () => {
        var isFormValid = CheckValidation({ formID: 'addcustomermodal' });
        if (!isFormValid) return;
        setLoading(true);
        var base64File = null;
        try {
            base64File = await convertToBase64(uploadedFile?.Document);
        } catch (error) {
            log.error("Error converting file to base64:", error);
        }
        const raw = JSON.stringify({
            customerId: null,
            enrollment: null,
            customer: null,
            partnerShipId: Groupid,
            schoolId: customerSchoolId,
            document: base64File,
        });
        await ApiPostCall("/schools/profile-info/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(
                        <AlertsComp show={true} variant="success" msg={"Document Uploaded Successfully."} />
                    );
                    setUploadedFile({ ...uploadedFile, FileName: '', Document: '' })
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        viewResellerStaffs(Groupid, 2);
                    }, 2000);
                    GetData(null, Params.Sortbykey, false);
                } else {
                    setNewAlerts(
                        <AlertsComp show={true} variant="danger" msg={responseRs.message} />
                    );
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    };
    const totalCustomerBody = (
        <div className="px-2">
            <div className='col-12 text-end mb-2'>
                <button
                    title='Add Customer'
                    className="SaveBtn cursor-pointer"
                    style={{ background: "var(--primary-color)", color: "white" }}
                    onClick={(e) => {
                        setaddnewcustomerflag(1);
                        setCustomerSchoolId(0);
                        setUploadedFile({ ...uploadedFile, FileName: '', Document: '' });
                        GetAllSchoolsByLocation({ setAllSchool })
                    }}>
                    Add Customer
                </button>
            </div>
            <div className="px-2 mb-3">
                {
                    addnewcustomerflag == 1 &&
                    <div className='row parent greyBox mt-3' id="addcustomermodal">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <div className='FormLabel pb-2 fw-600'>Select Customer<label className='redText'>*</label></div>
                                <div className="ps-0">
                                    <select required className='form-select' value={customerSchoolId}
                                        onChange={(e) => setCustomerSchoolId(e.target.value)}>
                                        <option value={0}>Select</option>
                                        {AllSchool?.length > 0 && AllSchool.map((item, i) => {
                                            return <option key={i} value={item.id}>{item.name}</option>
                                        })}
                                    </select>
                                    <span className="form-text invalid-feedback" > *required </span>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className='FormLabel pb-2 fw-600'>Upload Document</div>
                                <input
                                    type="file"
                                    ref={UploadDocFile}
                                    name="upload_fileforimportdevices"
                                    id="UploadFileForResellers"
                                    accept='.pdf'
                                    onChange={ShowFileName}
                                />
                                <label className='col-8 ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileForResellers" style={{ borderRadius: '15px' }}>
                                    <img src='/images/Attachment_Icon.svg' className='img-fluid pe-2' />
                                    PDF
                                </label>

                            </div>
                            <div className='col-md-12 pe-0'>
                                <div className="ps-2" style={{ fontWeight: "600" }}>
                                    {uploadedFile?.Document && (
                                        <label className='d-flex'>
                                            <label onClick={(e) => openPDFInNewTab(uploadedFile?.Document)}>
                                                <u>{uploadedFile.FileName || uploadedFile?.Document}</u>
                                            </label>
                                            <img className='ps-2' src="/images/CancelIcon.svg" title='Remove' onClick={() => setUploadedFile({ ...uploadedFile, FileName: '', Document: '' })} />
                                        </label>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className='col-12 text-center mt-3'>
                            <label className="ms-2 cursor-pointer" onClick={(e) => {
                                setaddnewcustomerflag(0); setCustomerSchoolId(0); setUploadedFile({ ...uploadedFile, FileName: '', Document: '' })
                            }}><u>Cancel</u></label>
                            <button
                                className="ms-2 SaveBtn cursor-pointer"
                                style={{
                                    background: "var(--primary-color)", color: "white"
                                }}
                                onClick={() => {
                                    handleSaveSchoolDocument();
                                }}>
                                Save
                            </button>
                        </div>
                    </div>
                }
            </div>
            {viewResellersData?.attached_schools?.length > 0 ? (
                <div className='col-12 greyBox data-table-container'>
                    <table className="table data-table mb-0" >
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col">Name </th>
                            </tr>
                        </thead>
                        <tbody>
                            {viewResellersData.attached_schools.map((item, i) => {
                                return <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                    <td className='py-12'>
                                        {item.school_name}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="text-center">No Customers Found.</div>
            )}
        </div>
    );
    function handleTabClick(tabType) {
        if (tabType == "var") {
            setTabs({ ...tabs, var: "active", msp: "" });
        } else if (tabType == "msp") {
            setTabs({ ...tabs, var: "", msp: "active" });
            setGridData([]);
        }
    }

    return (
        <>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"External Entities"}
                handleSearch={handleSearchChange}
                loading={loading} Alerts={NewAlerts} showsearch={true} />
            <div className="GridBox mt-2 p-3">
                <div className='row align-items-center'>
                    <div className="col-md-8 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={tabs.var == 'active'}
                                label="VARs" onClick={() => handleTabClick('var')} col={'col-md-3'} />
                            <Tab isActive={tabs.msp == 'active'}
                                label="MSPs" onClick={() => handleTabClick('msp')} col={'col-md-3'} />
                        </ul>
                    </div>
                    <div className='col-md-4 text-end pe-0'>
                        {tabs.var == 'active' &&
                            <label title='Add VAR' className="BorderBtn text-center" onClick={handleGroupModal}>
                                Add VAR
                                <img src="/images/AddInventory.svg" className="img-fluid ps-2" />
                            </label>
                        }
                    </div>
                </div>
                <div className="col-12 greyBox mt-3 data-table-container">
                    {tabs?.var == 'active' ?
                        <table className="table data-table mb-0">
                            <thead className="GridHeader">
                                <tr>
                                    <th scope="col" title='Sort by Group Name' className="cursor-pointer fw-600" onClick={(e) => GetData(SearchForGroup, "name", true)}>Group Name
                                        <img src="/images/sortbynew.svg" alt={`Sort by Group Name`} className="img-fluid ps-2 sortbyClass" /> </th>
                                    <th scope="col" title='Sort by Group Domain' className="cursor-pointer fw-600" onClick={(e) => GetData(SearchForGroup, "domain", true)}>Group Domain
                                        <img src="/images/sortbynew.svg" alt={`Sort by Group Domain`} className="img-fluid ps-2 sortbyClass" /> </th>
                                    <th scope="col" className="fw-600">Total Users</th>
                                    <th scope="col" className="fw-600">Total Customers</th>
                                    <th scope="col" className=" fw-600">Action </th>
                                </tr>
                            </thead>
                            <tbody>
                                {GridData.length != 0 ? (
                                    GridData.map((item, i) => {
                                        return <tr key={i} className={`OddEvenClass tableBorderHide `}>
                                            <td className="py-12">{item.name}</td>
                                            <td className="py-12">{item.domain}</td>
                                            <td className="py-12">
                                                <u className='cursor-pointer' onClick={(e) => { getGroupEditData(item.id); viewResellerStaffs(item.id, 1) }}>
                                                    {item.resellergroupusers_count}
                                                </u>
                                            </td>
                                            <td className="py-12">
                                                <u className='cursor-pointer' onClick={(e) => { getGroupEditData(item.id); viewResellerStaffs(item.id, 2) }}>
                                                    {item.schools_count}</u></td>
                                            <td className="py-12">
                                                <img src="/images/EditIconNew.svg" title="Edit Group"
                                                    className="img-fluid pe-2 cursor-pointer"
                                                    onClick={(e) => {
                                                        getGroupEditData(item.id);
                                                        setGroupModal(true);
                                                        setGroupaddupdateflag(2);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    })
                                ) : (
                                    <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                                )}
                            </tbody>
                        </table>
                        :
                        <table className="table data-table mb-0">
                            <thead className="GridHeader">
                                <tr>
                                    <th scope="col" className="fw-600">Company Name</th>
                                    <th scope="col" className="fw-600">Email</th>
                                    <th scope="col" className="fw-600"> Register Date</th>
                                    <th scope="col" className="fw-600"> Web Url</th>
                                </tr>
                            </thead>
                            <tbody>
                                {GridData.length != 0 ? (
                                    GridData.map((item, i) => {
                                        return <tr key={i} className={`OddEvenClass tableBorderHide `}>
                                            <td className="py-12">{item.company_name || '-'}</td>
                                            <td className="py-12">{item.email || '-'}</td>
                                            <td className="py-12">{item.register_date ? formatDateToMMDDYYYY(item.register_date) : '-'}</td>
                                            <td className="py-12">{item.web_url || '-'}</td>

                                        </tr>
                                    })
                                ) : (
                                    <tr> <td colSpan={18} className="p-3 text-center"> No Record Found </td> </tr>
                                )}
                            </tbody>
                        </table>
                    }
                </div>

                {showPagination && (
                    <Pagination activePage={currentPage} totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15} itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                        itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
                )}
            </div>

            <Popup isshow={GroupModal} size={"md"}
                title={Groupaddupdateflag == 1 ? 'Add VAR' : 'Edit VAR'}
                closePopup={(e) => { setGroupModal(false); }}
                modalBody={groupBody} handleSave={(e) => handleSavegroup(1)} visibleSaveBtn={true} btnText={
                    Groupaddupdateflag == 1 ? 'Save'
                        : 'Update'
                } />
            <Popup isshow={MSPModal} size={"xl"}
                title={MSPAddUpdateFlag == 1 ? 'Add MSP' : 'Edit MSP'}
                closePopup={(e) => { setMSPModal(false); }}
                modalBody={<Expresstechform closePopup={(e) => { setMSPModal(false) }} />}
            />
            <Popup isshow={ViewUsersPopup} size={"lg"}
                title={'View Users'}
                closePopup={(e) => { setViewUsersPopup(false); setUserAddUpdateFlag(0); setEditingUserId(null); }}
                modalBody={groupusersBody} visibleSaveBtn={false}
            />

            <Popup isshow={ViewCustomersPopup} size={"lg"}
                title={'View Customers'}
                closePopup={(e) => { setViewCustomersPopup(false); setaddnewcustomerflag(0); setCustomerSchoolId(0); setUploadedFile({ ...uploadedFile, FileName: '', Document: '' }) }}
                modalBody={totalCustomerBody} visibleSaveBtn={false}
            />
        </>
    )
}
